'use strict';

var _ = require('lodash');
var DetailsLengthOfStayGridDataRetrieverService = function DetailsLengthOfStayGridDataRetrieverService($q, pricingAnalysisCommonsDataService, momentService, $filter) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function retrieveData(service, snapshotDate) {
    return pricingAnalysisCommonsDataService.retrieveLengthOfStayData(service, true, snapshotDate);
  }
  function getOneMatchingOriginalServiceId(data, originalServiceId) {
    var allMatchingOriginalServiceIds = _.filter(data, {
      serviceId: originalServiceId
    });
    if (_.isEmpty(allMatchingOriginalServiceIds)) {
      return [];
    }
    var oneMatchingOriginalService = _.clone(pricingAnalysisCommonsDataService.getLatestService(allMatchingOriginalServiceIds));
    var isExcluded = _.some(allMatchingOriginalServiceIds, {
      isExcluded: true
    });
    oneMatchingOriginalService.isExcluded = isExcluded;
    return oneMatchingOriginalService;
  }
  function getOthersNotMatchingOriginalServiceId(data, originalService) {
    var services = _.filter(data, function (row) {
      return row.serviceId !== originalService.serviceId && row.direction === originalService.revertedDirection;
    });
    return _.uniqBy(services, 'serviceIdWithClass');
  }
  function transform(data, originalService) {
    var toTransform = [].concat(getOneMatchingOriginalServiceId(data, originalService.serviceId)).concat(getOthersNotMatchingOriginalServiceId(data, originalService));
    return _.transform(toTransform, function (result, row, key) {
      _.forEach(row.fareClassAvailabilityList, function (fareClassAvail, fareClassKey) {
        var classAvailLastIndex = row.fareClassAvailabilityList.length - 1;
        result.push({
          direction: formatDirection(row.direction),
          flightNbr: transformToFlightNumbers(row.displayServiceId),
          departureDate: rmMomentFormat(momentService.of(row.departureDate, momentService.FIELD.PRICING_DEPARTURE_DATE), momentService.DATE_USER_SETTINGS),
          fareClass: fareClassAvail.fareClass,
          isExcluded: row.isExcluded,
          averageFare: fareClassAvail.averageFare,
          atpcoSellUp: fareClassAvail.atpcoSellUp,
          originalAvailability: fareClassAvail.originalAvailability,
          recommendedAvailability: fareClassAvail.recommendedAvailability,
          recommendedStrategy: row.recommendationStrategy,
          age: row.age,
          validity: row.validity,
          isServiceGroupEnd: classAvailLastIndex === fareClassKey && data[key + 1] !== undefined,
          dpAdjustmentClass: row.dpAdjustmentClass,
          dpAdjustments: row.dpAdjustments
        });
      });
    }, []);
  }
  function formatDirection(direction) {
    return _.chain(direction).toLower().upperFirst().value();
  }
  function transformToFlightNumbers(displayServiceId) {
    return (displayServiceId || '').replace(/\|/g, '/');
  }
  function filterDataBySelectedLengthOfStayOrSelectedService(data, referenceService) {
    return _.filter(data, function (service) {
      return service.lengthOfStay === referenceService.lengthOfStay || _.isNil(service.lengthOfStay);
    });
  }
  function getSelectedServiceData(data, originalService) {
    return _.filter(data, function (service) {
      return service.key === originalService.key;
    });
  }
  function prepareData(data, referenceService, originalService) {
    if (referenceService) {
      return filterDataBySelectedLengthOfStayOrSelectedService(data, referenceService);
    }
    return getSelectedServiceData(data, originalService);
  }
  function getData(referenceService, originalService, snapshotDate) {
    return retrieveData(originalService, snapshotDate).then(_.partialRight(prepareData, referenceService, originalService)).then(pricingAnalysisCommonsDataService.filterServicesThatMatchLatestClass).then(_.partialRight(transform, originalService));
  }
  return {
    getData: getData
  };
};
DetailsLengthOfStayGridDataRetrieverService.$inject = ['$q', 'PricingAnalysisCommonsDataService', 'MomentService', '$filter'];
module.exports = DetailsLengthOfStayGridDataRetrieverService;